export const calculateEpaAverage = (reportChartRadonValue) => {
  const rawData = reportChartRadonValue || [];
  const data =
    rawData.length > 0 && Array.isArray(rawData[0]) ? rawData.flat() : rawData;

  // EPA average excludes the first 4 hourly data points.
  if (data.length <= 4) {
    return null;
  }

  let sum = 0;
  let count = 0;
  for (let i = 4; i < data.length; i++) {
    const value = Number(data[i]?.radon_level);
    if (Number.isFinite(value)) {
      sum += value;
      count++;
    }
  }

  return count === 0 ? null : sum / count;
};

export const reformatRadonAvgData = (data, unit, point) => {
  if (
    data === "" ||
    data === undefined ||
    data === null ||
    !Number.isFinite(Number(data))
  ) {
    return "--";
  }

  if (unit === 0) {
    return Number(data).toFixed(point) + " pCi/L";
  }

  return Number(data).toFixed(0) + " Bq/m3";
};
